import React from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="navbar navbar-dark bg-dark px-3">
      <Link className="navbar-brand" to="/">Means Collection</Link>
      <Link className="btn btn-warning" to="/cart">Cart</Link>
    </nav>
  );
}